<div class="bg-footer-2 text-center pt-2 pb-2">
    <img height="100px" src="assets/img/viettel-icon.png" />
    <div class="permission ml-1 mr-1">Cơ quan chủ quản: Tập đoàn Công nghiệp - Viễn thông Quân đội. Giấy phép số: 144/GP-BC do Bộ Thông tin - Truyền thông cấp ngày 18/04/2007</div>
</div>